<template>
    <div class="table-container">
        <div class="title">
            <span>
                User List
            </span>
            <div>
                <v-btn class="edit-btn" @click="goToCreateUser()">
                    Add New User
                </v-btn>
            </div>
        </div>
        <array-view
            :items="users"
            :headers="headers"
            :total-pages="totalPages"
            :page="page"
            :size="size"
            :is-fetching="isFetchingUsers"
            @paginationChange="paginationChange"
        />
    </div>
</template>

<script>
    import userService from '@/services/user-service'
    import ArrayView from '@/components/ArrayView'
    export default {
        components: { ArrayView },
        data() {
            return {
                headers: [
                    { text: 'Id', value: 'id' },
                    { text: 'Username', value: 'username' },
                    { text: 'Admin', value: 'parentUsername' },
                    { text: 'Enabled', value: 'active' },
                    { text: 'Actions', align: 'center', value: 'actions', sortable: false }
                ],
                users: [],
                totalPages: 0,
                size: 5,
                page: 1,
                sortKey: 'id',
                sortOrder: 'ASC',
                isFetchingUsers: false
            }
        },
        watch: {
            page: 'applyFiltersToQuery',
            size: 'applyFiltersToQuery',
            sortKey: 'applyFiltersToQuery',
            sortOrder: 'applyFiltersToQuery'
        },
        created() {
            this.initializeFilters()
            this.fetchAllUsers()
        },
        methods: {
            paginationChange(page, size) {
                this.size = size
                this.page = page
                this.fetchAllUsers()
            },
            goToCreateUser() {
                this.$router.push('/users/create')
            },
            fetchAllUsers() {
                this.isFetchingUsers = true
                userService.getUsers(this.page, this.size, this.sortKey, this.sortOrder)
                    .then(resp => {
                        this.users = resp.data.content || []
                        this.totalPages = resp.data.totalPages || 0
                    })
                    .catch(error => {
                        console.error('Error fetching users:', error)
                    })
                    .finally(() => {
                        this.isFetchingUsers = false
                    })
            },
            initializeFilters() {
                const query = this.$route.query
                if (query.page) this.page = parseInt(query.page)
                if (query.pageSize) this.size = parseInt(query.pageSize)
                if (query.sortKey) this.sortKey = query.sortKey
                if (query.sortOrder) this.sortOrder = query.sortOrder
            },
            applyFiltersToQuery() {
                const query = {
                    page: this.page,
                    pageSize: this.size,
                    sortKey: this.sortKey,
                    sortOrder: this.sortOrder
                }
                this.$router.replace({ query })
            }
        }
    }
</script>

<style scoped>
.title {
    font-size: 1.5rem !important;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.edit-btn {
    text-transform: none !important;
    background: #00acd6 !important;
    color: white;
    margin: 15px auto;
}
</style>
